import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private usersService: UsersService
  ) {}

  canActivate(_r, state: RouterStateSnapshot) {
    return this.usersService.user$.pipe(
      map(user => {
        const loggedIn = !!user;
        this.usersService.redirectUrl = loggedIn ? null : state.url;
        return loggedIn || this.router.parseUrl('/users/signin');
      })
    );
  }
}
